@use '../../style/mixins';

:host(limel-split-button.has-menu) {
    --button-padding-right: 2rem;
}

:host(limel-split-button) {
    display: inline-flex;
    isolation: isolate;

    * {
        box-sizing: border-box;
    }
}

limel-button {
    width: 100%;
}

$distance-around-trigger: 0.125rem;

limel-menu {
    display: flex;
    justify-content: flex-end;
    position: relative;
    z-index: 1;

    padding: $distance-around-trigger;
    margin-left: calc(var(--button-padding-right) * -1);
    width: var(--button-padding-right);

    &:before {
        transition: background-color 0.5s ease;
        content: '';
        position: absolute;
        inset: 0.375rem auto 0.375rem 0.6875rem;
        width: 1px;
        background-color: currentColor;

        opacity: 0.2;
    }

    &:not([disabled]) {
        color: var(
            --lime-primary-color,
            var(--limel-theme-primary-color)
        ); // similar to limel-button text

        &.primary {
            color: var(
                --lime-on-primary-color,
                var(--limel-theme-on-primary-color)
            ); // similar to limel-button text
        }
    }

    &[disabled] {
        color: rgba(var(--contrast-1600), 0.37); // similar to limel-button text
    }

    &:hover,
    &:focus-within {
        &:before {
            background-color: transparent;
        }
    }
}

.menu-trigger {
    all: unset;

    text-align: center;
    font-weight: bold;

    border-radius: 0.125rem;
    height: 100%;
    width: 1rem;

    &:not(:disabled) {
        @include mixins.is-flat-clickable(
            $color: 'inherit',
            $color--hovered: 'inherit'
        );
        @include mixins.visualize-keyboard-focus();
        cursor: pointer;

        &:focus-visible,
        &:hover {
            background-color: rgb(var(--color-white), 0.1);
        }
    }

    &[aria-expanded]:not([aria-expanded='false']) {
        box-shadow: var(--button-shadow-inset-pressed);
    }

    &:before {
        // prevents unintentionally activating the default action,
        // by clicking on the edge of menu trigger,
        // which would be activating the default onClick action
        // on `limel-button`.
        content: '';
        position: absolute;
        inset: -$distance-around-trigger * 2;
        z-index: -1;
    }
}
